<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="undecided-history-detail">
      <Title class="_title" :jpn="t('履歴')" />
      <HistoryHeader />
      <p class="undecided-list-message"> {{ t('未選択のお品物は24時間でポイントへ自動変換されます') }}</p>
      <div class="undecided-list" v-if="undecidedList && undecidedList.list">
        <div class="undecided-list-detail" v-for="(cardsByKey,date) in undecidedList.list" :key="date">
        <GreenGradationButton
          class="green-button"
          :isHeading="true"
          :text="`${t('未選択一覧')}: ${date}`"
        />
        <div class="card-list-container-wrapper">
          <div class="card-list-container" v-for="(cardList, key) in cardsByKey" :key="key">
            <CardList :cardList="cardList" />
            <BuyButton
              :isArrow="false"
              class="label-input nomt decide_button"
              :text="t('選択する')"
              @handleSquareBtnClick="() => handleClick('usePoint', { id: key })"
            />
          </div>
        </div>
      </div>
      <BoxPager
          v-if="
            undecidedList &&
            undecidedList.page &&
            undecidedList.page.pages
          "
          class="box-pager"
          :totalPageCount="undecidedList.page.all_page"
          :currentPageCount="undecidedList.page.page"
          :dispBoxCount="undecidedList.page.pages.length"
          :pages="undecidedList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
          />
        </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import GreenGradationButton from '@/components/atoms/GreenGradationButton.vue';
import CardList from '@/components/organisms/CardList.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';

export default {
  name: 'UndecidedDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    HistoryHeader,
    GreenGradationButton,
    CardList,
    BoxPager,
    BuyButton,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      undecidedList: 'pending/undecidedList',
    }),
    translatedBackText() {
      return this.t('一覧に戻る');
    },
  },

  methods: {
    goToBuyProductHistoryDetail(packHistoryId) {
      // メモ: beforeEnterでrouterに記載するとエラーとなるので、こちらに記載
      (async () => {
        // const query = {
        //   packHistoryId,
        // };
        await this.$store.dispatch('packHistory/setCurrentPackHistory', { packHistoryId });
        const currentPackHistory = this.$store.getters['packHistory/currentPackHistory'];
        const isDivision = currentPackHistory.status === '1';
        if (isDivision) {
          this.$router.push('/');
        } else {
          this.$router.push('/get-card-list');
        }
      })();
    },
    handleClick(dispKey, item) {
      if (dispKey === 'usePoint') {
        this.goToBuyProductHistoryDetail(item.id);
      }
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pending/setUndecidedList', { pageNumber });
  },
};
</script>

<style lang="scss" scoped>
.undecided-history-detail{
  position: relative;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 0;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .square-button{
      width: 200px;
      height: 40px;
    }
  }
  .border-area {
    margin: 30px 10px 0;
    padding: 10px 0;
    color: $white;
  }
  .undecided-list-message{
    margin: 5px auto;
    text-align: center;
    font-size: large;
    color: $gray;
    @media screen and (max-width: $tabletWidth) {
      font-size: 14px;
    }
  }
}
.undecided-list{
  .undecided-list-detail{
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width:auto;
    max-width: 873px;
    .green-button{
      width: 100%;
    }
    .card-list-container-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 16px;
      flex-direction: column;
      .card-list-container{
        width: 100%;
        padding: 5px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
        border-radius: 10px;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .decide_button{
          width: 35%;
          min-width: 150px;
          height: 40px;
          z-index: 2
        }
      }
    }
  }
}
</style>
